
import ProfileTick from "../../../assets/duotone/ProfileTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ProfileTickIcon({ className, dataTestid = "ProfileTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ProfileTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
